module.exports = __webpack_public_path__ + "static/img/12.2c88355.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/eng/12.png
// module id = PROL
// module chunks = 0